var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 1H4.125C3.2962 1 2.50134 1.26339 1.91529 1.73223C1.32924 2.20107 1 2.83696 1 3.5V23.5C1 24.163 1.32924 24.7989 1.91529 25.2678C2.50134 25.7366 3.2962 26 4.125 26H22.875C23.7038 26 24.4987 25.7366 25.0847 25.2678C25.6708 24.7989 26 24.163 26 23.5V6.58628L20.3333 1Z",
    stroke: "#747474",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.95459,
    y: 1,
    width: 8.92857,
    height: 7.30519,
    stroke: "#747474",
    strokeWidth: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.54541,
    y: 17.0714,
    width: 15.9091,
    height: 8.92857,
    stroke: "#747474",
    strokeWidth: 1.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDefault);
export default __webpack_public_path__ + "static/media/Save_Default.14d83817da8a2b32098894166f4fb072.svg";
export { ForwardRef as ReactComponent };